import {Injectable, EventEmitter, Output} from '@angular/core';

import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/finally';

import {environment} from '../../../environments/environment';
import {DataService} from './data.service';

import {HttpHeaders} from '@angular/common/http';

import {SpinnerService} from './spinner.service';
import {UtilsService} from './utils.service';

@Injectable()
export class OfferPriceDataService {

    private debugVerbose = false;


    constructor(private data: DataService,
                private spinnerService: SpinnerService,
                private utilsService: UtilsService
    ) {  }

    private getHeader(): HttpHeaders {
        let headers = new HttpHeaders();
        const programId = sessionStorage.getItem('currentProgram');
        this.utilsService.debugLog(programId);
        if (programId) {
            headers = headers.set('Program', programId);
        }

        return headers;
    }

    getProgramPrice() : Observable<any>{
        const url = environment.program_price_url;
        this.utilsService.debugLog('Getting offer price for program');
        this.spinnerService.show('offerSpinner');
        return this.data.get(url, this.getHeader())
                .finally(() => {
                    this.spinnerService.hide('offerSpinner');
                });
    }

    setProgramPrice(price: string): Observable<any>{
        this.spinnerService.show('offerSpinner');
        const body = { };
        const url = environment.program_price_url + '?price=' + price;

        return this.data.post(url, body, this.getHeader()).map((response) => {
            return response;
        }).finally(() => {
            this.spinnerService.hide('offerSpinner');
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/offer-price-data.service.ts